import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class SubCategoryService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.SUB_CATEGORIES(), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.SUB_CATEGORIES_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.SUB_CATEGORIES(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.SUB_CATEGORIES(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.SUB_CATEGORIES(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.SUB_CATEGORY_STATUS(id), data);
    }
}
